export default __webpack_public_path__ + "static/media/expl-gradcam_12_EN.631b1d17.png";